module.exports = __webpack_public_path__ + "img/tarjetas.c94befce.png";